import { encodeFunctionData, erc20Abi } from 'viem';
export async function transferERC20(params) {
    const { recipient, contractAddress, amount, signer, smartAccount } = params;
    const callData = encodeFunctionData({
        abi: erc20Abi,
        functionName: 'transfer',
        args: [recipient, amount],
    });
    return smartAccount.sendUserOp({
        toAddress: contractAddress,
        callData,
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'transferERC20',
    });
}
